export const environment = {
  production: true,
  appPage: "app.aspx",
  apiUrlBackEnd: "https://adp-sgd-mesapartes-prod-eus-api.azurewebsites.net",
  recaptchaSiteKey: '6LcHoDYpAAAAAHuxhZ69zjpGPwb4jEodkYLOZUqR',
  abreviaturaEmpresa: "ADP",
  urlLogo: "https://adpaleprodeusstgacc.blob.core.windows.net/imagenes/logo-svg.svg",  
};